import { forwardRef } from 'react';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import { cn } from 'lib/utils';

const SecondaryTarget = forwardRef(function SecondaryTarget(
  {
    label,
    query,
    className = 'block py-1 px-4',
    setCurrentSelection,
    onTargetClick,
    id,
  },
  ref
) {
  const matches = AutosuggestHighlightMatch(label, query);
  const parts = AutosuggestHighlightParse(label, matches);

  return (
    <div
      onClick={() => onTargetClick(label)}
      onMouseEnter={() => setCurrentSelection(id)}
      onMouseLeave={() => setCurrentSelection()}
      ref={ref}
      aria-label={label}
      tabIndex={0}
      className={className}
    >
      {parts.map(({ text, highlight }, index) => (
        <span
          key={index}
          className={cn({
            'text-smd-accent': highlight,
          })}
        >
          {text}
        </span>
      ))}
    </div>
  );
});

export default SecondaryTarget;
